import { IonGrid } from '@ionic/react';
import { ComponentProps, PropsWithChildren } from 'react';

// Styles
import styles from '@/components/DataTable/DataTable.module.css';

export const DataTable = ({ children }: PropsWithChildren<ComponentProps<typeof IonGrid>>) => {
  return (
    <IonGrid className={styles.table} fixed>
      {children}
    </IonGrid>
  );
};
